import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { AssetSummary, AdvancedSettings } from './';
import { withFlags } from '../../flags/Flags';

import './DashboardOverview.scss';

class DashboardOverview extends Component {
  componentDidMount() {
    this.props.actions.getAssetAttributes();
    this.props.actions.getAssetSummary();
    this.props.actions.getRules();
  }

  render() {
    const { summary } = this.props.assets;
    const chartRows = [
      {
        type: 'active',
        sum: summary.active
      },
      {
        type: 'expired',
        sum: summary.expired
      }
    ];
    return withFlags(flags => (
      <div className="dashboard-overview">
        {summary ? (
          <AssetSummary
            summary={summary}
            chartRows={chartRows}
            {...this.props}
          />
        ) : null}
        <AdvancedSettings flags={flags} {...this.props} />
      </div>
    ));
  }
}

DashboardOverview.contextTypes = {
  router: PropTypes.object
};

DashboardOverview.propTypes = {
  assets: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  imports: PropTypes.object.isRequired,
  rules: PropTypes.object.isRequired,
  actions: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(DashboardOverview);
